var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kimsa-confirm',{ref:"confirm",attrs:{"title":_vm.title,"content":_vm.content,"confirm-label":_vm.$t('common.accept'),"alert-mode":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }